import { Toolbar, Typography, Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

export default function TableToolbar({ numSelected, handleDeleteAll }) {
  return (
    <div>
      

      {numSelected > 0 && (
        <Button
        style={{width:"max-content"}}
          variant="contained"
          color="error"
          startIcon={<DeleteIcon />}
          onClick={handleDeleteAll}
        >
          Delete All
        </Button>
      )}
</div>
  );
}
